const EmailModalBody = (props) => {
  return (
    <>
      <div className="modal-header text-center p-0 bg-primary popup-heading-color justify-content-center">
        <input type="hidden" id="logged-in-user" value="{{client.client_user.id}}" />
        <h5
          className="modal-title mx-auto font-size-24 height-35 font-weight-semibold text-uppercase popup-heading-color font-weight-500"
          id="avatarModalTitle"
        >
          Send Chat Message to &nbsp;
          <div className="ic ic-29 chat-popup">
            <img className="output-3 theme-ring" src="/bp_assets/img/avatar_new.svg" />
          </div>
          &nbsp; Client Name
        </h5>
      </div>
      <p className="p-l-10 p-r-10 p-t-5 p-b-5 client-popup-border text-center" id="">
        Your Chat Message for this poup goes here.
      </p>
      <div className="modal-body">
        <div className="btn-group mt-2 ChatB4 justify-content-center" role="group">
          <button
            type="button"
            className="btn btn-primary-lighter btn-white-hover text-lg height-25 rounded-0 d-flex align-items-center justify-content-center p-l-6 p-r-5"
            onclick="updateChatBoxPopUp(this)"
          >
            Testing 1
          </button>
          <button
            type="button"
            className="btn btn-primary-lighter btn-white-hover text-lg height-25 rounded-0 d-flex align-items-center justify-content-center p-l-6 p-r-5 ms-2"
            onclick="updateChatBoxPopUp(this)"
          >
            Testing 2
          </button>
          <button
            type="button"
            className="btn btn-primary-lighter btn-white-hover text-lg height-25 rounded-0 d-flex align-items-center justify-content-center p-l-6 p-r-5 ms-2"
            onclick="updateChatBoxPopUp(this)"
          >
            Testing 3
          </button>
          <button
            type="button"
            className="btn btn-primary-lighter btn-white-hover text-lg height-25 rounded-0 d-flex align-items-center justify-content-center p-l-6 p-r-5 ms-2"
            onclick="updateChatBoxPopUp(this)"
          >
            Testing 4
          </button>
        </div>
        <div className="form-check notification-float-right">
          <input
            className="form-check-input example-checkbox"
            type="checkbox"
            value=""
            id="exampleCheckbox-{{client.client_user.id}}"
            data-firstname="{{client.first_name}} {{client.last_name}}"
            checked
          />
          <label className="form-check-label" for="exampleCheckbox-{{client.client_user.id}}">
            Include chat subject greeting
          </label>
        </div>
        <label for="w3review mt-3">Chat Subject Greeting:</label>
        <input
          className="custom-text-input notification-border-solid-1px-grey-width-100P-padding-10px"
          type="text"
          value="From the Search Page regarding Kamran Hassan:"
          disabled
        />
        <div>
          <label for="w3review" className="mt-3">
            Type Message:
          </label>
          <textarea
            type="text"
            className="chatMessage notification-border-solid-1px-grey-width-100P-padding-10px"
            name="chatMessage"
            rows="4"
            cols="50"
          />
        </div>
      </div>

      <div className="modal-footer notification-padding-2rem">
        <button
          type="button"
          id=""
          className="btn btn-success input-group-text send_btn notification-position-absolute-right-14px-background-color-218838-color-white-border-color-218838 save-btn-popup popup-heading-color"
          onClick={props.hideModal}
        >
          Send Chat Message
        </button>
        <button
          type="button"
          className="btn btn-danger  notification-background-color-grey-border-color-grey-position-absolute-left-14px"
          onClick={props.hideModal}
        >
          Close
        </button>
      </div>
    </>
  );
};

export default EmailModalBody;
